import API from "api/client";
import { QuestionSample } from "types";
import { envConfig } from "config";

const { questionSamplesAPI } = envConfig;

const updateQuestionSamplePriority = (id: number, priority: number): Promise<QuestionSample> => {
  return API.put(`${questionSamplesAPI}${id}/priority`, { priority }).then((res) => res.data);
};

const stopQuestionSample = (id: number): Promise<QuestionSample> => {
  return API.put(`${questionSamplesAPI}${id}/stop`).then((res) => res.data);
};

export default {
  updatePriority: updateQuestionSamplePriority,
  stop: stopQuestionSample,
};
